import React, { useState, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import "primeicons/primeicons.css";
import "../../styles/custom-tabview.css";
import axios from "axios";

import NouvellesFiches from "./nouvellesFiches";
import SuivisFiches from "./suivisFiches";
import ValidesFiches from "./validesFiches";
import RealisesFiches from "./realisesFiches";
import ToutesFiches from "./toutesLead";
import AbandonsFiche from "./abandons";
import DashboardLeads from "./dashboardLead";
import Relances from "./relances";
const apiUrl = process.env.REACT_APP_API_URL;

const TABS = [
  { label: "Nouvelles", key: "nouvelles" },
  { label: "Relances", key: "relance" },
  { label: "Envoyés",    key: "en_suivi" },
  { label: "Réalisés",  key: "realises" },
  { label: "Abandons",  key: "abandons" },
  { label: "Tous",      key: "toutes" },
];

export default function LeadsList() {
  const [activeIndex, setActiveIndex] = useState(() => {
    const s = localStorage.getItem("activeTabIndexLeads");
    return s !== null ? parseInt(s) : 0;
  });

  const [counters, setCounters] = useState({
    nouvelles: 0, en_suivi: 0,
    realises: 0, abandons: 0, toutes: 0,
  });

  const [globalSearch, setGlobalSearch] = useState("");

  // Mesure la largeur RÉELLE de la barre (pas celle de l'écran)
  // pour décider si tabs + recherche tiennent côte à côte.
  const barRef = useRef(null);
  const [isCompact, setIsCompact] = useState(true);

  useEffect(() => {
    const el = barRef.current;
    if (!el) return;

    const BREAKPOINT = 650; 
    let frameId = null;

    const observer = new ResizeObserver((entries) => {
     
      if (frameId) cancelAnimationFrame(frameId);
      frameId = requestAnimationFrame(() => {
        const width = entries[0].contentRect.width;
        setIsCompact(width < BREAKPOINT);
      });
    });

    observer.observe(el);
    return () => {
      if (frameId) cancelAnimationFrame(frameId);
      observer.disconnect();
    };
  }, []);

  const changeTab = (index) => {
    setActiveIndex(index);
    localStorage.setItem("activeTabIndexLeads", index);
  };

  useEffect(() => {
    axios.get(`${apiUrl}/IHM/api/lead.php?pannel=true`)
      .then(res => setCounters(res.data))
      .catch(err => console.error("Erreur compteurs:", err));
  }, [activeIndex]);

  return (
    <>
      <DashboardLeads />

      <div
        style={{
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* BARRE TABS + RECHERCHE */}

        <div
          ref={barRef}
          className="flex gap-2 p-2"
          style={{
            flexDirection: isCompact ? "column" : "row",
            justifyContent: isCompact ? "flex-start" : "space-between",
            alignItems: isCompact ? "stretch" : "center",
            gap: isCompact ? "8px" : "12px",
          }}
        >
          {/* Tabs */}
          <div
            style={{
              overflowX: "auto",
              WebkitOverflowScrolling: "touch",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              minWidth: 0,
            }}
            className="hide-scrollbar"
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "nowrap",
                gap: "4px",
                minWidth: "max-content",
              }}
            >
              {TABS.map((tab, i) => {
                const isActive = i === activeIndex;
                return (
                  <div
                    key={i}
                    onPointerDown={() => changeTab(i)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "0 12px",
                      height: "35px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      flexShrink: 0,
                      backgroundColor: isActive ? "#0d0d0d" : "transparent",
                      touchAction: "manipulation",
                      WebkitTapHighlightColor: "transparent",
                      userSelect: "none",
                    }}
                  >
                    <span
                      style={{
                        color: isActive ? "#f5c542" : "#6b6b6b",
                        fontWeight: isActive ? 700 : 500,
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {tab.label}
                    </span>
                    <span
                      style={{
                        marginLeft: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "50%",
                        fontWeight: "bold",
                        fontSize: "10px",
                        width: "18px",
                        height: "18px",
                        backgroundColor: isActive ? "#f5c542" : "transparent",
                        color: isActive ? "#0d0d0d" : "#9a9a98",
                        flexShrink: 0,
                      }}
                    >
                      {counters[tab.key] ?? 0}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Search */}
          <div
            style={{
              flexShrink: 0,
              width: isCompact ? "100%" : "20rem",
            }}
          >
            <IconField iconPosition="left" style={{ width: "100%" }}>
              <InputIcon className="pi pi-search" />
              <InputText
                value={globalSearch}
                onChange={(e) => setGlobalSearch(e.target.value)}
                placeholder="Rechercher un client..."
                className="w-full"
              />
            </IconField>
          </div>
        </div>
        {/* CONTENU */}
        <div style={{ padding: "1rem 0 0 0" }}>
          {activeIndex === 0 && <NouvellesFiches searchTerm={globalSearch} />}
          {activeIndex === 1 && <Relances searchTerm={globalSearch} />}
          {activeIndex === 2 && <SuivisFiches searchTerm={globalSearch} />}
          {activeIndex === 3 && <RealisesFiches searchTerm={globalSearch} />}
          {activeIndex === 4 && <AbandonsFiche searchTerm={globalSearch} />}
          {activeIndex === 5 && <ToutesFiches searchTerm={globalSearch} />}
        </div>
      </div>
    </>
  );
}